import React from 'react';
import { SEO } from './components/SEO';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { CompanionCategories } from './components/CompanionCategories';
import { Services } from './components/Services';
import { ContactCTA } from './components/ContactCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-dark-900 text-cream selection:bg-gold-500/30 selection:text-gold-200" data-id="element-0">
      <SEO data-id="element-1" />
      <Navbar data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <About data-id="element-5" />
        <CompanionCategories data-id="element-6" />
        <Services data-id="element-7" />
        <ContactCTA data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}